import { useState } from 'react';
import automobyApi from '../Api';
import { useUpdateEffect } from './useUpdateEffect';

export const useWebsite = (defaultPageSize) => {
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0); 
  const [filter, setFilter] = useState({
    all: true,
    limit: defaultPageSize,
    order_by: "id",
    page: 1,
    name: "", 
  });

  useUpdateEffect(() => {
    fetchList();
  }, [filter]);
 
  const fetchList = async () => {
    try {
      const response = await automobyApi.post("/website/list", filter)
      setItems(response.data.websites);
      setTotal(response.data.total);
      return response.data.websites
    } catch (error) { 
      console.error("თუ ერორია:" + error);
    }
  }

  const fetch = async () => {
    try {
      const requestData = {
        all: true,
        limit: 100,
        order_by: "id",
        offset: 1
      };

      const response = await automobyApi.post("/website/all", requestData)
      setItems(response.data.websites);
      setTotal(response.data.total);
      return response.data.websites
    } catch (error) {

      console.error("თუ ერორია:" + error);
    }
  }

  const add = async (newData) => {
    try {
      const response = await automobyApi.post(`/website/create`, newData);
      fetchList();
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  const search = async (website, count) => {
    try {
      const requestData = {
        website: website,
        count: count,
      };

      const response = await automobyApi.post("/website/search", requestData)
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  const update = async (newData) => {
    try {
      const response = await automobyApi.post(`/website/update`, newData);
      fetchList();
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  const remove = (id) => {
    return new Promise(async (resolve, reject) => {
      try {
        const requestData = {
          website_id: id
        };
        const response = await automobyApi.post(`/website/delete`, requestData);
        fetchList();
        resolve(response);
      } catch (error) {
        reject(error);
      }
    });
  } 

 

  const websiteService = {
    items: items,
    total: total,
    filter: filter, 
    setFilter: setFilter,
    fetch: fetch,
    fetchList: fetchList,
    add: add,
    search: search,
    update: update,
    remove: remove, 
  };

  return { websiteService };
}